import Layout from '@/layout/Layout'

export const asyncRouters = [
  // 替换成自己项目的路由
  {
    path: '/reconciliation',
    component: Layout,
    redirect: '/reconciliation/collecting',
    name: 'reconciliation',
    meta: { title: '财务对账' },
    children: [{
      path: 'collecting',
      name: 'collecting',
      component: () =>
        import('@/views/reconciliation/index'),
      meta: { title: '代收业务' }
    }
    ]
  }
]
